/*=========================================================================================
  File Name: moduleReportActions.js
  Description: Report Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Api from "@/helpers/api.js";
import {payloadGenerator} from "../../helpers/payloadGenerator";

export default {
	createReport({commit}, {reportType, payload}) {
		// Se agrega la siguiente validacion para cambiar el end-point del servicio cuando es historicalposition
		// esto para utilizar el nuevo servicio
		return new Promise((resolve, reject) => {
			Api.post("/report/" + reportType, payload)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	createVisitPointReport({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/report/visitpoint", payload)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	getHistoryReport({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/downloads", payload)
				.then((response) => {
					if (payload.group_by_process) {
						const processData = [];
						Object.keys(response.data).forEach((key) => {
							processData.push({...response.data[key], process_id: key});
						});
						commit("SET_DOWNLOAD_REPORTS", processData);
					} else {
						commit("SET_DOWNLOAD_REPORTS", response.data);
					}
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	deleteHistoryReport({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.delete(`/downloads/${payload.process_id}/${payload.numFile}`)
				.then((response) => {
					if (payload.numFile === 0) {
						commit("DELETE_DOWNLOAD_REPORT", payload.process_id);
					} else {
						commit("REMOVE_FILE_DOWNLOAD_REPORT", payload);
					}
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	async getHistoryReportsFilter({commit}, params) {
		const payload = payloadGenerator(params, "Download");
		const response = await Api.post("/downloads/filter", payload);
		if (response.data.records) {
			commit("SET_FILES_REPORT", response.data.records);
			return response.data.records;
		} else {
			return response;
		}
	},
	async getProcessFilter({commit}, params) {
		const payload = payloadGenerator(params, "Process");
		const response = await Api.post("/process/filter", payload);
		if (response.data.records) {
			commit("SET_DOWNLOAD_REPORTS", response.data.records);
			return response;
		} else {
			return response;
		}
	},
};
